import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import ActionTable from "../../components/table/ActionTable";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";

export default function Profissionais({ history, location }) {
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [lista, setLista] = useState([]);
  const [chaveGerar, setChaveGerar] = useState(false);
  const [filtros, setFiltros] = useState(
    mergeParams({ escolaId: 0 }, location)
  );

  useEffect(() => {
    carregarComboEscolas();
    filtros.escolaId > 0 && listarChaves();
  }, []);

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((escolas) => {
      setComboEscolas(escolas);
    });
  };

  const listarChaves = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    api
      .get("chavesAcesso/listar", filtrosEnviar)
      .then((chaves) => {
        setLista(chaves);
      })
      .catch((err) => {
        notification("error", "Erro ao listar as Chaves de acesso");
      });
  };

  const carregarChaves = () => {
    if (filtros.escolaId === 0)
      return notification("warning", "Selecione uma escola");
    setChaveGerar(true);
  };

  const fEscolas = {
    title: "Filtros",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtros.escolaId,
      },
    },

    submit: {
      label: "listar",
      action: listarChaves,
    },

    urlParams: true,
    history,
    location,
  };

  const gerarChaves = (param) => {
    api
      .put("chavesAcesso/gerar", {
        escolaId: filtros.escolaId,
        quantidade: param.quantidade,
      })
      .then((res) => {
        notification("success", "Chaves geradas com sucesso!");
        setChaveGerar(false);
        listarChaves();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Escola inválida");
          case 2:
            return notification("error", "Quantidade inválida");

          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fChaves = {
    title: "Gerar chaves",
    form: {
      quantidade: {
        label: "Quantidade",
        type: "number",
      },
    },

    submit: {
      label: "gerar",
      action: gerarChaves,
    },
    close: {
      label: "Fechar",
      action: () => {
        setChaveGerar(false);
      },
    },
  };

  const tbChaves = {
    title: "Chaves da Acesso",
    newItemAction: () => carregarChaves(),
    columns: [
      {
        label: "Chave",
        name: "chave",
      },
      {
        label: "Geração",
        name: "geracao",
      },
      {
        label: "Ativação",
        name: "ativacao",
      },
      {
        label: "Profissional",
        name: "profissionalNome",
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={fEscolas} />
      {chaveGerar && filtros.escolaId && <Form formData={fChaves} />}
      {filtros.escolaId ? (
        <ActionTable structure={tbChaves} />
      ) : (
        <h5>
          Selecione uma escola e clique em "Listar" para exibir as chaves
          geradas ou gerar novas.
        </h5>
      )}
    </div>
  );
}
